import { IStyle, memoizeFunction, mergeStyleSets } from '@fluentui/react';
import { IAppEffects, IAppTheme, useAppTheme } from 'common/theme';

const getStyles = memoizeFunction(
  (
    theme: IAppTheme,
    depth: keyof IAppEffects = 'elevation8',
    width: number | string = 'auto',
    maxWidth: number | string = 'auto',
    minWidth: number | string = 'auto'
  ) => {
    return mergeStyleSets({
      root: {
        backgroundColor: theme.palette.white,
        borderRadius: 8,
        boxShadow: theme.effects[depth],
        width,
        maxWidth,
        minWidth,
      } as IStyle,
    });
  }
);

export const useCardStyles = (
  depth?: keyof IAppEffects,
  width?: number | string,
  maxWidth?: number | string,
  minWidth?: number | string
) => {
  const theme = useAppTheme();
  return getStyles(theme, depth, width, maxWidth, minWidth);
};
